// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4081":"d36d89e6798b728a","4343":"989e0e49f5b39eab","6648":"d8289b9da41f17a6","7778":"919a1d527efc8fc2","9797":"426f9221a4a5be3b"}[chunkId] + ".css";
};